<template>
  <div>
    <el-dialog
        :visible.sync="dialogVisible"
        :custom-class="!isPC ? 'auth-dialog auth-dialog-h5' : 'auth-dialog auth-dialog-pc'"
        :close-on-click-modal="false"
        append-to-body
        top="25vh"
        :show-close="false"
        :width="!isPC ? '320px' : '460px'"
        >
        <div class="content">
            <img v-if="!isPC" class="close-icon" src="../../TUIKit/assets/icon/close-image.png" @click="handleClose">
            <img v-else class="close-icon" src="@/assets/img/index/authPop_close.png" @click="handleClose">
            <div :class="['real-name-wrap', 'text-wrap', docRealNameStatus == 1 ? 'sucess-wrap' : '']">
                <span class="text">
                    <span class="status-icon"></span>
                    本人实名认证
                    <div class="line"></div>
                </span>
                <span class="status">{{docRealNameStatus == 1 ? '已完成' : '未完成'}}</span>
            </div>
            <div :class="['text-wrap', signStatus == 1 ? 'sucess-wrap' : '']">
                <span class="text">
                    <span class="status-icon"></span>
                    设置手写签名
                </span>
                <span class="status">{{signStatus == 1 ? '已完成' : '未完成'}}</span>
            </div>
            <el-button v-if="isPC" class="tip-btn" round >请前往手机端完成认证</el-button>
            <el-button v-else-if="!isPC && docRealNameStatus != 1" class="btn auth-btn" round @click="handleGoCertification">去认证</el-button>
            <el-button v-else-if="!isPC && signStatus != 1" class="btn sign-btn" round @click="handleGoSign">去签名</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { getPlatform } from "@tencentcloud/universal-api";
import { getRealNameAuthInfo, getCaAgreementUrl } from '@/api/cf.js'
export default {
    name: 'realNameAuthPop',
    props: {
        isInit: {
            default: false // true:在初始化的时候校验, false:在交互后校验
        },
        type: {
            default: ''
        }
    },
    data() {
        return {
            isPC: getPlatform() === 'pc',
            dialogVisible: false,
            docRealNameStatus: 0, // 1:已认证 0:未认证
            signStatus: 0, // 0:未签名 1:已签名
            info: {}
        }
    },
    created() {
        sessionStorage.removeItem('authResource');
        this.isInit && this.handleCheckRealNameAuth();
    },
    methods: {
        async handleShow() {
            await this.handleCheckRealNameAuth();
            return this.dialogVisible
        },
        handleClose() {
            this.dialogVisible = false
        },
        // 查询医生三要素及认证状态
        async handleCheckRealNameAuth() {
            const res = await getRealNameAuthInfo();
            if(res.code === 20000){
                this.docRealNameStatus = res.data.docRealNameStatus;
                this.signStatus = res.data.signStatus;
                this.dialogVisible = this.docRealNameStatus != 1 || this.signStatus != 1 ;
            }
        },
        // 去认证
        async handleGoCertification() {
            const res = await getCaAgreementUrl();
            if (res?.code === 20000) {
                sessionStorage.setItem('authResource', JSON.stringify({
                    name: this.$route.name,
                    query: this.$route.query
                }));
                window.location.href = res?.data?.agreementUrl;
            }
            // this.$router.push({ name: 'realNameAuth' })
        },
        // 去签名
        handleGoSign() {
            this.$router.push({ name: 'signature' })
        }
    }
}
</script>

<style lang="less" scoped>
::v-deep .auth-dialog{
    background-color: transparent;
    box-shadow: none;
    .el-dialog__body{
        padding: 0;
    }
    .content{
        .text-wrap{
            display: flex;
            justify-content: space-between;
            
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            .text{
                display: flex;
                align-items: center;
                position: relative;
                font-weight: 600;
                .status-icon{
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    margin-right: 9px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 4px 0px rgba(20,160,230,0.3);
                    border: 1px solid #14A0E6;
                    border-radius: 50%;
                }
            }
            .status{
                color: #F75C16;
            }
        } 
        .sucess-wrap{
            .text .status-icon{
                background: #14A0E6;
            }
            .status{
                color: #14A0E6;
            }
        }
        .real-name-wrap{
            margin-bottom: 36px;
        }
        .line{
            position: absolute;
            top: 20px;
            left: 6px;
            width: 1px;
            height: 38px;
            border-left: 1px dashed #E0E2E4; 
        }
        .close-icon{
            width: 24px;
            height: 24px;
            position: absolute;
        }
    }
}
::v-deep .auth-dialog-pc{
    .content{
        width: 380px;
        height: 150px;
        background-image: url('@/assets/img/index/authPopBg_pc.png');
        background-size: 100% 100%;
        padding: 126px 40px 20px;
        position: relative;
        .close-icon{
            top: 20px;
            right: 24px;
        }
        .tip-btn{
            margin: 24px 0 0 32px;
            width: 315px;
            height: 44px;
            background: rgba(40,157,228,0.15);
            border-radius: 22px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 15px;
            color: #289DE4;
        }
    }

}
::v-deep .auth-dialog-h5{
    .content{
        width: 280px;
        height: 142px;
        background-image: url('@/assets/img/index/authPopBg_h5.png');
        background-size: 100% 100%;
        padding: 102px 20px 20px;
        position: relative;
        .btn{
            margin-top: 24px;
            width: 280px;
            height: 42px;
            background: #14A0E6;
            border-radius: 21px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
        }
        .close-icon{
            top: -12px;
            right: -12px;
        }
    }
}
</style>